// extracted by mini-css-extract-plugin
module.exports = {"avatarContainer":"avatarContainer--5Yspq","dropdownMenu":"dropdownMenu--IoL-c","menuTitle":"menuTitle--pUNlb","drawerMenu":"drawerMenu--kOKVK"};